import { useEffect, useState } from "react";
import * as firebaseui from "firebaseui";
import { auth } from "../../config/firebase-config";
import { GoogleAuthProvider, signInWithEmailAndPassword } from "firebase/auth";
import "firebaseui/dist/firebaseui.css";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const uiConfig: firebaseui.auth.Config = {
      signInSuccessUrl: "/authenticated",
      signInFlow: "popup",
      signInOptions: [
        // Leave the lines as is for the providers you want to offer your users.
        GoogleAuthProvider.PROVIDER_ID,
      ],
    };
    const ui =
      firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(auth);

    ui.start("#firebaseui-auth-container", uiConfig);
  }, []);

  const signIn = async (e: any) => {
    e.preventDefault();
    try {
      const userCredentials = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      if (userCredentials.user) {
        navigate("/authenticated");
      }
    } catch (e) {
      toast.error("Invalid email or password");
      console.error(e);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 to-amber-50">
      {/* Navigation remains the same - place your NavigationBar component here */}

      <div className="flex flex-col items-center justify-center px-4 pt-16 pb-32">
        <div className="w-full max-w-lg bg-white rounded-2xl shadow-lg overflow-hidden">
          {/* Header section */}
          <div className="px-8 pt-8 pb-2 text-center">
            <h1 className="text-3xl font-bold text-gray-800">Welcome back</h1>
            <p className="mt-2 text-gray-600">
              Log in to access your quizzes and reports
            </p>
          </div>

          {/* Form section */}
          <div className="px-8 py-6">
            <form onSubmit={signIn}>
              <div className="mb-4">
                <input
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-3 text-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500"
                  required
                />
              </div>

              <div className="mb-4">
                <input
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-4 py-3 text-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500"
                  required
                />
              </div>

              {/* Forgot password link */}
              <div className="mb-6 text-right">
                <a
                  href="/forgot-password"
                  className="text-sm text-yellow-600 hover:text-yellow-700"
                >
                  Forgot password?
                </a>
              </div>

              <button
                type="submit"
                disabled={!(email.length && password.length)}
                className={`w-full py-3 px-4 bg-gradient-to-r from-yellow-500 to-amber-500 text-white font-medium rounded-lg shadow-md 
                  ${
                    !(email.length && password.length)
                      ? "opacity-70 cursor-not-allowed"
                      : "hover:from-yellow-600 hover:to-amber-600"
                  } 
                  transition-all duration-200`}
              >
                Sign in
              </button>
            </form>

            {/* Divider */}
            <div className="my-6 flex items-center">
              <div className="flex-grow border-t border-gray-300"></div>
              <span className="mx-4 text-gray-600 font-medium">OR</span>
              <div className="flex-grow border-t border-gray-300"></div>
            </div>

            {/* Firebase UI container */}
            <div id="firebaseui-auth-container" className="w-full"></div>

            {/* Sign up link */}
            <div className="mt-6 text-center">
              <p className="text-gray-600">
                Don't have an account?{" "}
                <a
                  href="/register"
                  className="text-yellow-600 hover:text-yellow-700 font-medium"
                >
                  Sign up
                </a>
              </p>
            </div>
          </div>

          {/* Footer gradient section */}
          <div className="bg-gradient-to-r from-yellow-500 to-amber-500 p-8">
            <div className="text-white text-center">
              <h3 className="text-xl font-bold mb-2">Yippity Quiz Platform</h3>
              <p className="opacity-80">
                Create, share, and take quizzes with intelligent feedback.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
